module.exports = __webpack_public_path__ + "img/img30.eb5a14d7.jpg";